// reed-diffuser-script.js

document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded and parsed');
    const readMoreButtons = document.querySelectorAll('.read-more-btn');
    console.log('Found ' + readMoreButtons.length + ' Read More buttons');

    readMoreButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            console.log('Button clicked');
            const card = this.closest('.fragrance-card');
            const shortDescription = card.querySelector('.short-description');
            const longDescription = card.querySelector('.long-description');
            
            console.log('Short description classes: ' + shortDescription.className);
            console.log('Long description classes: ' + longDescription.className);

            if (longDescription.classList.contains('hidden') || !longDescription.classList.contains('visible')) {
                shortDescription.classList.remove('visible');
                shortDescription.classList.add('hidden');
                longDescription.classList.remove('hidden');
                longDescription.classList.add('visible');
                this.textContent = 'Read Less';
                console.log('Showing long description');
            } else {
                shortDescription.classList.remove('hidden');
                shortDescription.classList.add('visible');
                longDescription.classList.remove('visible');
                longDescription.classList.add('hidden');
                this.textContent = 'Read More';
                console.log('Showing short description');
            }
        });
    });
});